<template>
    <div class="my-page">
      <!-- 用户信息卡片 -->
      <div class="user-card">
        <div class="avatar">
          <img src="https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1107.jpg" alt="头像" />
        </div>
        <div class="user-info">
          <h2 class="nickname">共富能手</h2>
          <p class="phone">手机号：138****8888</p>
        </div>
      </div>
  
      <!-- 我的订单 -->
      <div class="section">
        <h3>我的订单</h3>
        <ul class="order-list">
          <li v-for="order in orders" :key="order.id" class="order-item">
            <span class="order-type">{{ order.type }}：{{ order.name }}</span>
            <span class="order-status">状态：{{ order.status }}</span>
          </li>
        </ul>
      </div>
  
      <!-- 我的资产 -->
      <div class="section">
        <h3>我的资产</h3>
        <ul class="asset-list">
          <li v-for="asset in assets" :key="asset.id" class="asset-item">
            <span class="asset-name">{{ asset.type }}：{{ asset.name }}</span>
            <span class="asset-value">产权号：{{ asset.propertyId }}</span>
          </li>
        </ul>
      </div>
  
      <!-- 我的浏览记录 -->
      <div class="section">
        <h3>我的浏览记录</h3>
        <ul class="record-list">
          <li v-for="record in records" :key="record.id" class="record-item">
            <span class="record-title">{{ record.type }}：{{ record.name }}</span>
            <span class="record-time">时间：{{ record.time }}</span>
          </li>
        </ul>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent } from 'vue';
  
  export default defineComponent({
    name: 'MyPage',
    data() {
      return {
        // 我的订单：土地、房屋的购买或租赁记录
        orders: [
          { id: '1', type: '土地购买', name: '地块A', status: '已完成' },
          { id: '2', type: '房屋租赁', name: '房屋B', status: '进行中' },
          { id: '3', type: '土地租赁', name: '地块C', status: '待付款' },
        ],
        // 我的资产：土地、房屋的产权
        assets: [
          { id: '1', type: '土地', name: '地块A', propertyId: 'P123456' },
          { id: '2', type: '房屋', name: '房屋B', propertyId: 'P789012' },
          { id: '3', type: '土地', name: '地块C', propertyId: 'P345678' },
        ],
        // 我的浏览记录：首页查看的土地、房屋出租或出售记录
        records: [
          { id: '1', type: '土地出售', name: '地块X', time: '2023-10-01 12:00' },
          { id: '2', type: '房屋出租', name: '房屋Y', time: '2023-10-02 14:00' },
          { id: '3', type: '土地出租', name: '地块Z', time: '2023-10-03 16:00' },
        ],
      };
    },
  });
  </script>
  
  <style scoped>
  .my-page {
    padding: 20px;
    background-color: #f9f9f9; /* 页面背景色 */
  }
  
  .user-card {
    display: flex;
    align-items: center;
    padding: 20px;
    background-color: #fff; /* 白色背景 */
    border-radius: 10px;
    margin-bottom: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 阴影效果 */
  }
  
  .avatar img {
    width: 100px; /* 放大头像 */
    height: 100px; /* 放大头像 */
    border-radius: 50%;
    object-fit: cover; /* 确保图片比例正常 */
  }
  
  .user-info {
    margin-left: 20px;
  }
  
  .nickname {
    margin: 0;
    font-size: 24px;
  }
  
  .phone {
    margin: 5px 0 0;
    color: #666;
  }
  
  .section {
    margin-bottom: 20px;
    padding: 20px;
    background-color: #fff; /* 白色背景 */
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 阴影效果 */
  }
  
  .section h3 {
    margin-bottom: 10px;
    font-size: 20px;
  }
  
  .order-list,
  .asset-list,
  .record-list {
    list-style: none;
    padding: 0;
  }
  
  .order-item,
  .asset-item,
  .record-item {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    background-color: #f9f9f9; /* 列表项背景色 */
    border: 1px solid #eee; /* 边框颜色 */
    border-radius: 5px;
    margin-bottom: 10px;
  }
  
  .order-type,
  .asset-name,
  .record-title {
    font-weight: bold;
  }
  
  .order-status,
  .asset-value,
  .record-time {
    color: #666;
  }
  </style>